import Vue from 'vue'
import Router from 'vue-router'

import corpList from '@/components/corpList'
import login from '@/components/login'
import register from '@/components/register'
import downLoad from '@/components/downLoad'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: login
    },
    {
      path: '/corpList',
      component: corpList
    },
    {
      path: '/register',
      component: register
    },
    {
      path: '/downLoad',
      component: downLoad
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js